import React from 'react'
import { Box, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';

const StudentTools = (props) => {
  return (
    <Box
    sx={{
      mb: '10px',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    }}
    >
      <Typography sx={{ m: 1 }} variant="h5">
        Student
      </Typography>
      <Box
        sx={{ m: 1 }}
        onClick={() => {
          props.setIsAddButton(true);
          props.setOpen(true);
          props.setEditStudent('');
        }}
      >
        <Stack direction="row" spacing={2}>
          <Fab 
            style={{background:'variant',color:'white'}}
            variant="extended" size="medium" color="primary" aria-label="add">
            <AddIcon sx={{ mr: 1 }} />
            Add Student
          </Fab>
        </Stack>
      </Box>
    </Box>
  )
}

export default StudentTools
